// Brand context theming & header logo behavior
// - Uses metafields (data-page-brand) to determine brand context
// - Applies brand class / data attributes on <body>
// - Defaults to 'zileej' if no metafield is found
// NOTE: The canonical brand map is provided by Liquid on window.__BRAND_MAP__

(function () {
  'use strict';

  var BRAND_CLASS_PREFIX = 'brand--';
  var BRAND_MAP = window.__BRAND_MAP__ || {};
  var DEFAULT_BRAND = 'zileej';

  function normalizeBrandKey(key) {
    if (!key) return null;
    key = key.toLowerCase().trim();
    // Normalize known brand key variations
    if (key === '5pillars') return '5-pillars';
    if (key.indexOf('salam') !== -1) return 'salam-sisters';
    if (key === 'zileej' || key === 'zillej') return 'zileej';
    return key;
  }

  // Get brand key from page metafield (data-page-brand attribute)
  function getBrandFromPage() {
    var body = document.body;
    if (!body) return null;
    var key = body.getAttribute('data-page-brand');
    if (!key) return null;
    var normalized = normalizeBrandKey(key);
    if (normalized && BRAND_MAP[normalized]) return normalized;
    return null;
  }

  // Public helper: current brand key based on page metafield or default
  function getCurrentBrandKey() {
    var pageBrand = getBrandFromPage();
    // If no metafield found, default to 'zileej'
    return pageBrand || DEFAULT_BRAND;
  }

  function applyBrandContext(brandKey) {
    var body = document.body;
    if (!body) return;

    var key = brandKey || getCurrentBrandKey();

    // Clear if key is invalid or "all"
    if (!key || key === 'all' || !BRAND_MAP[key]) {
      body.removeAttribute('data-brand-active');
      // Remove existing brand--* classes
      var classes = Array.prototype.slice.call(body.classList || []);
      classes.forEach(function (c) {
        if (c.indexOf(BRAND_CLASS_PREFIX) === 0) {
          body.classList.remove(c);
        }
      });
      return;
    }

    // Set active brand attribute and class for existing CSS
    body.setAttribute('data-brand-active', key);

    var classes2 = Array.prototype.slice.call(body.classList || []);
    classes2.forEach(function (c) {
      if (c.indexOf(BRAND_CLASS_PREFIX) === 0) {
        body.classList.remove(c);
      }
    });
    body.classList.add(BRAND_CLASS_PREFIX + key);

    // Optional: update main header logo alt text to include brand label
    var brandConfig = BRAND_MAP[key];
    if (brandConfig && brandConfig.label) {
      var headerLogoImg = document.querySelector('.header-logo__image-container img');
      if (headerLogoImg && headerLogoImg.setAttribute) {
        headerLogoImg.setAttribute('alt', brandConfig.label + ' logo');
      }
    }
  }

  function init() {
    if (typeof document === 'undefined') return;
    var body = document.body;
    if (!body) return;

    // Apply brand context based on page metafield (or default to zileej)
    applyBrandContext();

    // Expose helper for other scripts if needed
    window.getCurrentBrandKey = window.getCurrentBrandKey || getCurrentBrandKey;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

